<template>
  <div>
    <TopBar :page="topBarData" @menuItemClick="topMenuClicked"/>
    <v-container fluid>
      <v-btn v-if="showSave" fixed :loading="save_loading===1" :color="(save_loading===2)?'secondary':'accent'" rounded class="mt-1 mr-5" style="height:40px;bottom:20px;right:10px;z-index:1000;" @click="saveRetentionLead" :disabled="disableWhenClosed"><v-icon class="mr-2" small>{{(save_loading===2)?'check':'save'}}</v-icon> {{(save_loading===2)?'Saved':'Save'}}</v-btn>

      <v-container v-if="loading_prods" fluid><v-row><v-col><loader/></v-col></v-row></v-container>

      <template v-if="!loading_prods" fluid>
        <v-row>
          <v-col cols="12" md="4" class="align-stretch" height="100%">
            <v-card height="100%">

              <v-card-title>Retention Lead</v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12" md="5">
                    <div>
                      <span class="mb-1 text-caption mr-1">Age</span>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon small v-bind="attrs" v-on="on">help</v-icon>
                        </template>
                        <span>Time since the customer’s first sold date</span>
                      </v-tooltip>
                    </div>
                    
                    <p class="display-1 accent--text">{{ `${currentAccount.age} mnth` }}</p>
                  </v-col>

                  <v-col cols="12" md="7">

                    <template v-if="!updateStatusOpen">
                      <p class="mb-1 text-caption">Status 
                        <v-tooltip :disabled="disableEditStatusTooltip" top>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <v-icon small @click="updateStatusOpen=true" :disabled="disableEditStatus">edit</v-icon>
                            </span>
                          </template>

                          <span>Please save your changes before changing the status</span>
                        </v-tooltip>
                      </p>
                      <p class="display-1 accent--text">{{ ret_account.status }}</p>
                    </template>

                    <template v-else>
                      <div class="d-flex justify-start align-center">
                        <v-select v-model="ret_account.status" label="Status" :items="statuses" :disabled="getCrmUsersLoading" :loading="getCrmUsersLoading" @change="isStatusClosed()" outlined hide-details class="mr-2"></v-select>
                        
                        <div class="d-flex justify-start align-center">
                          <v-icon color="secondary" :loading="saveRetentionLeadLoading" :disabled="saveRetentionLeadLoading" @click="saveUpdateStatus" class="mr-1">check</v-icon>
                          <v-icon color="error" :loading="saveRetentionLeadLoading" :disabled="saveRetentionLeadLoading" @click="closeUpdateStatus">close</v-icon>
                        </div>
                      </div>
                    </template> 

                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <p class="mb-1 text-caption">Created by</p>
                    <p><b>{{ret_account.created_by | notEmpty}}</b></p>
                  </v-col>
                  <v-col>
                    <p class="mb-1 text-caption">Created</p>
                    <p><b>{{ret_account.created | notEmpty}}</b></p>
                  </v-col>
                  <v-col>
                    <p class="mb-1 text-caption">Closed</p>
                    <p><b>{{ret_account.closed | notEmpty}}</b></p>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>  
                    <v-autocomplete :items="getAgents" v-model="ret_account.agent_sid" label="Agent" item-text="long_name" hide-details outlined :loading="getCrmUsersLoading" :disabled="disableWhenClosed" @change="addChange('agent_sid',ret_account.agent_sid)"></v-autocomplete>
                  </v-col>

                  <v-col>
                    <v-select :items="getDropdowns.providers" v-model="ret_account.winning_provider" label="Winning provider" hide-details outlined :disabled="disableWhenClosed"  @change="addChange('winning_provider',ret_account.winning_provider)"></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="6">
                    <v-select :items="getDropdowns.sources" v-model="ret_account.source" label="Source" hide-details outlined :disabled="disableWhenClosed" @change="addChange('source',ret_account.source)"></v-select>
                  </v-col>

                  <v-col cols="6" class="d-flex justify-start">
                    <v-checkbox v-model="ret_account.no_contact" label="No Contact" :disabled="disableWhenClosed" @change="addChange('no_contact', ret_account.no_contact)" hide-details ></v-checkbox>
                  </v-col>           
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          
          <v-col cols="12" md="4">
            <CancellationCard>
              <template v-if="!singleRetentionLead.adhoc_invoice_id && singleRetentionLead.proforma_invoice_id" #titleBtn>
                <SendAdhocInvoice :accountId="account_id" />
              </template>
            </CancellationCard>
          </v-col>

          <v-col cols="12" md="4">
            <v-card class="align-stretch" height="100%">
              <v-card-title class="d-flex justify-space-between">
                <div>Billing account</div>
                <v-btn v-if="parseFloat(currentAccount.balance) > 0" color="secondary" x-small :href="`${ledger_url}payments/${this.currentAccount.id}?email=${encodeURIComponent(this.currentAccount.email_address)}`" target="_blank" :disabled="disableWhenClosed">
                  <v-icon small class="mr-1">{{ mdiCreditCardOutline }}</v-icon>
                  Take Payment
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <p class="mb-1 text-caption">Balance</p>
                    <p class="display-1 accent--text">£{{ currentAccount.balance || creditData!==undefined ? currentAccount.balance || creditData.balance : '--.--' }}</p>
                    <v-row>
                      <v-col>
                        <p class="mb-1 text-caption">Last Invoice</p>
                        <p><b>----/--/-- £--.--</b></p>
                        <p class="mb-1 text-caption">Payment Method</p>
                        <p><b>
                          {{ currentAccount.bill_cycle ? currentAccount.bill_cycle : "" }} - {{ currentAccount.payment_method ? currentAccount.payment_method : ""}} <br>
                          {{ currentAccount.payment_method === "DD" ? sort_code_account_num : ""}}
                        </b></p>
                      </v-col>
                      <v-col>
                        <p class="mb-1 text-caption">Credit Control</p>
                        <p><b>{{(currentAccount.credit_control_status!==null)?currentAccount.credit_control_status:'-'}}</b></p>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col>
                    <v-row>
                      <v-col>
                        <v-card>
                          <v-card-text>
                            <p class="mb-1 text-caption">Billing Contact</p>
                            <p><b>
                              {{ capitalizeFirstLetter(currentAccount.first_name) + ' ' + capitalizeFirstLetter(currentAccount.last_name) }} <br>
                              {{ currentAccount.email_address }} <br>
                              {{ currentAccount.phone_number }} <br>
                              {{ currentAccount.mobile_number }}
                            </b></p>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-card>
                          <v-card-text>
                            <p class="mb-1 text-caption">Billing Address</p>
                            <p><b>
                              <span class="d-block">
                                {{ currentAccount.address_line_one ? currentAccount.address_line_one.split(' ').map(str => capitalizeFirstLetter(str)).join(' ') : '' }}</span>
                              <span class="d-block">
                                {{ currentAccount.address_line_two ? currentAccount.address_line_two.split(' ').map(str => capitalizeFirstLetter(str)).join(' ') : '' }}</span>
                              <span class="d-block">
                                {{ currentAccount.address_city ? currentAccount.address_city.split(' ').map(str => capitalizeFirstLetter(str)).join(' ') : '' }}</span>
                              <span class="d-block">
                                {{ currentAccount.address_post_code }}</span>
                            </b></p>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="products">
              <v-card-title>Products</v-card-title>
              
              <v-card-text>

                <template v-for="(group, key) in retentionProducts">
                  <div :key="key" class="mb-6">

                    <div class="mb-4 text-body-1 products__subtitle">{{ group.title }}</div>

                    <v-data-table :headers="headers" :items="group.products" :expanded.sync="group.expanded" item-key="key" disable-filtering disable-pagination disable-sort hide-default-footer>
                      <template v-slot:header.cliUrl="{ header }">
                        <span class="pr-1">{{ header.text }}</span>
                        <BaseInfoTooltip top>The line number</BaseInfoTooltip>
                      </template>

                      <template v-slot:item.select="{ item }">
                        <v-checkbox :disabled="disableWhenClosed||item.is_selected" v-model="item.is_selected" @click.native.capture="selectProduct(item.id)"></v-checkbox>
                      </template>

                      <template v-slot:item.id="{ item }"><a :href="`/products/${item.id}`">{{ item.id }}</a></template>
                      
                      <template v-slot:item.cliUrl="{ item }"><span v-html="item.cliUrl"></span></template>
                      
                      <template v-slot:item.liveDate="{ item }">{{ item.liveDate | notEmpty }}</template>
                      
                      <template v-slot:item.contractEnd="{ item }">{{ item.contractEnd | notEmpty }}</template>
                      
                      <template v-slot:item.isTransfer="{ item }">
                        <v-checkbox v-model="item.cancel_record.is_transfer" :disabled="disableWhenClosed||!item.is_selected" @change="addChange(`cr__is_transfer__${item.canrec_id}`,item.cancel_record.is_transfer)"></v-checkbox>
                      </template>

                      <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length">
                          <v-row>
                            <v-col cols="12" md="2">
                              <v-select 
                                label="Retention"
                                :items="getRetentionProductStatuses" v-model="item.cancel_record.status" 
                                :disabled="disableWhenClosed||!item.is_selected" 
                                @change="addChange(`cr__status__${item.canrec_id}`,item.cancel_record.status)" 
                                outlined hide-details dense>
                              </v-select>
                            </v-col>
                            <v-col cols="12" md="2">
                              <v-select 
                                label="Saved Reason"
                                :items="getDropdowns.savedReasons" v-model="item.cancel_record.saved_reason" 
                                :disabled="disableWhenClosed||!item.is_selected||['WIP','Lost'].indexOf(item.cancel_record.status)!==-1" 
                                @change="addChange(`cr__saved_reason__${item.canrec_id}`,item.cancel_record.saved_reason)" 
                                outlined hide-details dense>
                              </v-select>
                            </v-col>
                            <v-col cols="12" md="2">
                              <v-menu :disabled="!(ret_account.status!=='Closed'&&item.is_selected)" v-model="item.transferDateOpen" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field :disabled="!(ret_account.status!=='Closed'&&item.is_selected)" label="Cease / Transfer Date" v-model="item.cancel_record.cease_or_transfer_date" readonly v-bind="attrs" v-on="on" outlined hide-details dense></v-text-field>
                                </template>
                                <v-date-picker v-model="item.cancel_record.cease_or_transfer_date" @input="item.transferDateOpen = false" @change="addChange(`cr__cease_or_transfer_date__${item.canrec_id}`,item.cancel_record.cease_or_transfer_date)">
                                  <v-spacer></v-spacer>
                                  <v-btn outlined small color="primary" @click="item.cancel_record.cease_or_transfer_date = '';addChange(`cr__cease_or_transfer_date__${item.canrec_id}`,item.cancel_record.cease_or_transfer_date)">CLEAR</v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" md="2">
                              <v-text-field
                                v-if="initial_status === 'Closed'"
                                label="Contact Reason Category"
                                :value="item.cancel_record.contact_category"  
                                outlined hide-details dense disabled>
                              </v-text-field>

                              <v-select
                                v-else
                                label="Contact Reason Category"
                                :items="getDropdowns.categories" v-model="item.cancel_record.contact_category" 
                                :disabled="disableWhenClosed||!item.is_selected" 
                                @change="addChange(`cr__contact_category__${item.canrec_id}`,item.cancel_record.contact_category.text);item.cancel_record.contact_reason='';item.cancel_record.contact_sub_reason=''" 
                                outlined hide-details dense return-object>
                              </v-select>
                            </v-col>
                            <v-col cols="12" md="2">
                              <v-text-field
                                v-if="initial_status === 'Closed'"
                                label="Contact Reason"
                                :value="item.cancel_record.contact_reason"  
                                outlined hide-details dense disabled>
                              </v-text-field>
                              
                              <v-select
                                v-else
                                label="Contact Reason"
                                :items="getDropdowns.reasons[item.cancel_record.contact_category.value]" v-model="item.cancel_record.contact_reason" 
                                :disabled="disableWhenClosed||!item.is_selected" 
                                @change="addChange(`cr__contact_reason__${item.canrec_id}`,item.cancel_record.contact_reason.text);item.cancel_record.contact_sub_reason=''" 
                                outlined hide-details dense return-object>
                              </v-select>
                            </v-col>
                            <v-col cols="12" md="2">
                              <v-text-field 
                                label="Contact Sub-reason"
                                :value="item.cancel_record.contact_sub_reason"  
                                outlined hide-details dense disabled>
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </td>
                      </template>  

                    </v-data-table>

                  </div>           
                </template>
            
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="8">
            <Notes notesType="retention" :id="id"/>
          </v-col>

          <v-col cols="12" md="4">
            <RetentionHistory :id="account_id" :heading="'Previous Retention Leads'" :filter="id" :disableAddLead="disableWhenClosed"/>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="8">
            <LeadAudit :lead_id="id"/>
          </v-col>
        </v-row>
      </template>

      <v-dialog v-model="status_to_closed" persistent max-width="1200">
        <v-card>
          <v-card-title>Close Retention Lead</v-card-title>
          <v-card-text>
            <p class="body--text">Please confirm all the actions in the table are correct:</p>

            <v-simple-table class="mb-4">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%">ID</th>
                    <th class="text-left" width="10%">Kind</th>
                    <th class="text-left" width="20%">CLI/URL</th>
                    <th class="text-left" width="25%">Cancel Reason</th>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <th class="text-center" v-bind="attrs" v-on="on" width="5%">
                          <v-img src="https://images.ctfassets.net/ywbljngut41j/2W5QaPV1b8IQL94YIRNLRV/dbbb4e16c6edb168089cf082473382c5/swap-horizontal.svg" width="15" class="d-block" style="margin: 0 auto;"></v-img>
                        </th>
                      </template>
                      <span>Cancellation is a transfer</span>
                    </v-tooltip>
                    <th class="text-left" width="30%">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(prod, ind) in retProducts">
                    <tr :key="ind" v-if="prod.ceased_date===null && prod.parent_product_id===null && prod.is_selected">
                      <!-- ID -->
                      <td width="10%" class="body--text">{{prod.id}}</td>
                      <!-- KIND -->
                      <td width="10%" class="body--text">{{kindNameMapping[prod.product_kind]}}</td>
                      <!-- CLI/URL -->
                      <td width="20%" class="body--text" v-if="prod.product_kind === 'web'"><a :href="prod.service.internal">{{prod.service.internal}}</a><br /><a :href="prod.service.external">{{prod.service.external}}</a></td>
                      <td width="20%" class="body--text" v-if="prod.product_kind === 'voip'"><template v-for="cli in prod.service.clis"><tr :key="cli">{{cli}}</tr></template></td>
                      <td width="20%" class="body--text" v-if="['voip','web'].indexOf(prod.product_kind)===-1">{{prod.service.line_number}}</td>
                      <!-- CANCEL REASON -->
                      <td width="25%" class="body--text">{{prod.cancel_record.cancel_reason}}</td>
                      <!-- IS TRANSFER -->
                      <td class="text-center body--text" width="5%"><v-checkbox v-model="prod.cancel_record.is_transfer" readonly></v-checkbox></td>
                      <!-- ACTION -->
                      <td width="30%" class="body--text">{{getClosedAction(prod,prod.product_kind)}}</td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>

            <template v-if="ret_account.no_contact">
              <v-alert color="warning" colored-border border="right" dense elevation="4">
                <template #prepend>
                  <v-icon large color="warning" class="mr-6">{{ mdiAlert }}</v-icon>
                </template>

                <div>The "No Contact" email and SMS will be sent to the customer</div>
              </v-alert>
            </template>

            <template v-if="!canCloseRetentionLead">
              <v-alert color="warning" colored-border border="right" dense elevation="4">
                <template #prepend>
                  <v-icon large color="error" class="mr-6">{{ mdiAlert }}</v-icon>
                </template>

                <div>Cannot close retention lead that is not assigned to you</div>
              </v-alert>
            </template>

            <template v-for="(item, i) in retProducts">
              <v-alert v-if="item.cancel_record.cease_or_transfer_date === moment(new Date()).format('YYYY-MM-DD')" color="warning" colored-border border="right" dense elevation="4" :key="i">
                <template #prepend>
                  <v-icon large color="warning" class="mr-6">{{ mdiAlert }}</v-icon>
                </template>

                <div>{{ item.id }} services will be ceased immediately</div>
              </v-alert>
            </template>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn text color="error" @click="status_to_closed=false;ret_account.status=initial_status;updates.status=initial_status">
              <template v-if="productsContactReason!==false">Cannot close retention lead unless {{productsContactReason}} is set</template>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" small :loading="loadingCloseRetentionLeadConfirm" :disabled="disableCloseRetentionLeadConfirm || !canCloseRetentionLead" @click="closeRetentionLead">CONFIRM</v-btn>
            <v-btn color="primary" small outlined :disabled="disableCloseRetentionLeadCancel" @click="status_to_closed=false;ret_account.status=initial_status;">CANCEL</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <SendProformaInvoiceDialog :open="sendProformaInvoiceOpen" :id="id" @closeDialog="sendProformaInvoiceOpen=false"/>
    </v-container>
  </div>
</template>

<script>
  import Loader from "@/components/Misc/Loader";
  import RetentionHistory from "@/components/Retention/HistoryTable";
  import SendAdhocInvoice from "@/components/Retention/SendAdhocInvoice";
  import TopBar from "@/components/Layout/TopBar";
  import LeadAudit from "@/components/Retention/LeadAudit";
  import CancellationCard from "@/components/Retention/CancellationCard";
  import SendProformaInvoiceDialog from "@/components/Retention/SendProformaInvoiceDialog";
  import Notes from '@/components/Globals/Notes/Notes';

  import { parsePhoneNumberFromString } from "libphonenumber-js";
  import { mapState, mapActions, mapGetters } from "vuex";
  import moment from "moment";
  import { mdiCreditCardOutline, mdiAlert } from "@mdi/js";

  export default {
    components: { Loader,RetentionHistory,SendAdhocInvoice,TopBar,LeadAudit,CancellationCard,SendProformaInvoiceDialog, Notes },

    filters: {
      notEmpty: (val)=>{
        return (val === null || val === "" || val === undefined)?'-':val;
      },
    },

    data() {
      return {
        headers: [
          { text: '', value: 'select' },
          { text: 'ID', value: 'id' },
          { text: 'Kind', value: 'kind' },
          { text: 'Status', value: 'status' },
          { text: 'CLI / URL', value: 'cliUrl' },
          { text: 'Live date', value: 'liveDate' },
          { text: 'Contract end', value: 'contractEnd' },
          { text: 'Is transfer', value: 'isTransfer' },
        ],
        topBarData: {
          name: 'loading...',
          type: 'retention',
          showSearch: true,
          menu: false,
          breadcrumbs: [
            {
              text: 'Billing Accounts',
              disabled: false,
              href: '/accounts/',
            },
          ],
          showBeehiveIcon: false,
        },
        ret_account: {},
        account: {},
        retProducts: {},
        loading_prods: true,
        isMounted: false,
        id: this.$route.params.id,
        account_id: '',
        kindNameMapping: {'web':'Website','voip':'VoIP','telco':'Telco'},
        all_disabled: false,
        any_changes: false,
        save_loading: 0,
        updates: {},
        initial_status: '',
        status_to_closed: false,
        sendProformaInvoiceOpen: false,
        ledger_url: process.env.VUE_APP_LEDGER_LINK || `https://ledger-test-bonline.appspot.com/`,
        mdiCreditCardOutline,
        mdiAlert,
        statuses: [],
        retentionLeadClosedSuccess: false,
        updateStatusOpen: false,
        moment,
      };
    },
    computed: {
      ...mapState('retention', ['singleRetentionLead','retentionLeadRecord']),
      ...mapState('accounts', ['currentAccount','accountEscalation','creditData']),
      ...mapState('products', ['products']),
      ...mapGetters('retention', ['getDropdowns', 'getAgentsLoading']),
      ...mapGetters('crmUsers', ['getTeamByRoles', 'getCrmUsersLoading']),
      ...mapGetters('globals', ['getCurrentUser', 'hasUserGotRoles']),

      canCloseRetentionLead() {
        if(this.hasUserGotRoles(['can-close-retention-leads-assigned-to-other-users'])) return true;
        if(this.ret_account.agent_sid === this.getCurrentUser.sid) return true;
        return false;
      },

      getRetentionProductStatuses() {
        return [...this.getDropdowns.retentions, "Transfer Rejected - No Contact"];
      },

      productsContactReason(){
        let ret = false;
        let selectedProducts = this.retentionProducts.find(products => products.title === 'Selected Products');
        
        selectedProducts.products.forEach(prod => {
          let cr = prod.cancel_record;
          if(cr.contact_reason.text===undefined){ ret = 'Contact Reason'; }
          if(cr.contact_category.text===undefined){ ret = 'Contact Category'; }
        });

        return ret;
      },

      retentionProducts(){
        const selectedProducts = {
          title: 'Selected Products',
          products: [],
          expanded: []
        };

        const otherProducts = {
          title: 'Other Products',
          products: [],
          expanded: []
        };

        Object.keys(this.retProducts).forEach((key) => {
          let prod = this.retProducts[key];
          if((prod.ceased_date===null && prod.parent_product_id===null)||(this.ret_account.status==='Closed'&&prod.is_selected)||(prod.is_selected)){
            let prodKind = prod.product_kind.toLowerCase();
            let cliUrl = this.sortCliUrl(prod);
            let cats = this.sortCancelCats(prod);
            prod.cancel_record.contact_category = cats.cat;
            prod.cancel_record.contact_reason = cats.rea;
            prod.cancel_record.contact_sub_reason = cats.sub;
            let obj = {
              ...prod,
              key: key,
              id: prod.id,
              kind: this.kindNameMapping[prodKind],
              status: prod.status,
              cliUrl: cliUrl,
              liveDate: prod.contract_start_date,
              contractEnd: prod.contract_end_date,
              ceaseTransferDate: prod.cancel_record.cease_or_transfer_date,
              isTransfer: (prod.cancel_record.is_transfer!==null)?(prod.cancel_record.is_transfer)?'Yes':'No':'No',
              cancel_record: prod.cancel_record,
            };

            if (prod.is_selected) {
              selectedProducts.products.push(obj);
              selectedProducts.expanded.push(obj);
            } else {
              otherProducts.products.push(obj);
            }
          }
        });

        return [selectedProducts, otherProducts];
      },

      sort_code_account_num() {
        const bank_acc_no = this.currentAccount.bank_acc_no;
        const sort_code = this.currentAccount.sort_code;
        let masked_no = "";
        let masked_sc = "";
        if(bank_acc_no){ masked_no = bank_acc_no.split("").map((n, i) => (i < bank_acc_no.length - 2 ? "*" : n)).join(""); }
        if(sort_code){ masked_sc = sort_code.split("").map((n, i) => (i < sort_code.length - 2 ? "*" : n)).join(""); }
        return `${masked_sc} - ${masked_no}`;
      },

      formattedPhoneNumber() {
        const phoneNumber = parsePhoneNumberFromString(String(this.currentAccount.phone_number),"GB");
        if(phoneNumber){ return phoneNumber.formatNational(); }
        return false;
      },

      formattedMobileNumber() {
        const phoneNumber = parsePhoneNumberFromString(String(this.currentAccount.mobile_number),"GB");
        if(phoneNumber){ return phoneNumber.formatNational(); }
        return false;
      },

      disableWhenClosed() {
        return this.ret_account.status === 'Closed';
      },
      
      loadingCloseRetentionLeadConfirm() {
        return this.save_loading !== 0;
      },

      disableCloseRetentionLeadConfirm() {
        return this.productsContactReason !== false || this.save_loading !== 0 || this.retentionLeadClosedSuccess;
      },

      disableCloseRetentionLeadCancel() {
        return this.save_loading !== 0 || this.retentionLeadClosedSuccess;
      },

      getAgents() {
        const agents = JSON.parse(JSON.stringify(this.getTeamByRoles(['retentions']))).sort((a, b) => a.long_name.localeCompare(b.long_name));
        const currentUserIndex = agents.findIndex(user => user.value === this.getCurrentUser.sid);

        if(currentUserIndex > -1) {
          const agent = agents[currentUserIndex];
          agents.splice(currentUserIndex, 1);
          agents.unshift(agent);
        }

        return agents;
      },
      
      saveRetentionLeadLoading() {
        return this.save_loading !== 0;
      },

      disableEditStatus() {
        if (this.any_changes) {
          const updates = Object.keys(this.updates);
          
          if (updates.length === 1 && updates.includes('status')) {
            return false;
          }
          
          return true; 
        }
        return this.disableWhenClosed;
      },

      disableEditStatusTooltip() {
        if (this.any_changes) {
          if (this.initial_status === 'New' && this.updates.hasOwnProperty('status') && this.updates.hasOwnProperty('agent_sid')) {
            return false;
          }

          if (!this.updates.hasOwnProperty('status')) {
            return false;
          }
        }

        return true;
      },

      showSave() {
        if (this.any_changes) {
          if (this.initial_status === 'New' &&  this.updates.hasOwnProperty('status') && !this.updates.hasOwnProperty('agent_sid')) {
            return false;
          }

          if (this.initial_status !== 'New' && this.updates.hasOwnProperty('status')) {
            return false;
          }

          return true;
        }
        return false;
      }
    },

    watch: {
      updates: {
        handler(val) {
          const updates = Object.keys(val);

          if (updates.length > 1 && updates.includes('status') && !updates.includes('agent_sid')) {
            delete this.updates.status;
            this.ret_account.status = this.initial_status;
            this.updateStatusOpen = false;
          }

          if (updates.length && this.updateStatusOpen) {
            if (!updates.includes('status') || (updates.includes('status') && updates.includes('agent_sid'))) {
              this.updateStatusOpen = false;
            }
          }  
        },
        deep: true      
      }
    },

    async mounted(){
      this.isMounted = true;
      await this.getRetentionLead(this.id);
      let data = this.singleRetentionLead;
      let pre_cancel_records = data.cancellation_records;
      let cancel_records = {};
      pre_cancel_records.forEach((rec)=>{ cancel_records[rec.product_id] = rec; });

      this.ret_account = data;
      this.initial_status = this.ret_account.status;
      this.account_id = data.account_id;
      this.ret_account.created = moment(this.ret_account.creation_timestamp).format('YYYY/MM/DD');
      this.ret_account.closed = (this.ret_account.closed_timestamp!==null)?moment(this.ret_account.closed_timestamp).format('YYYY/MM/DD'):'-';
      this.getAccountData();

      let setNames = setInterval(()=>{
        if(this.currentAccount.business_name!==undefined){
          this.topBarData.name = `${this.account_id} - ${this.currentAccount.business_name}`;
          this.topBarData.breadcrumbs.push(
            {text: `${this.account_id} - ${this.currentAccount.business_name}`,disabled: false,href: `/accounts/${this.account_id}/`},
            {text: `Retention Leads`,disabled: false,href: `/retention/`},
            {text: `${this.id}`,disabled: true,href: `/retention/${this.id}/`}
          );
          this.addRecentlyViewed({
            id: this.id,
            name: this.topBarData.name,
            type: 'retention-leads',
            status: this.ret_account.status,
            datetime: new Date()
          });
          clearInterval(setNames);
        }
      },250);

      await this.getAccountProducts(this.account_id);
      this.products.forEach(p=>{
        this.$set(this.retProducts, `p_${p.id}`, {
          cancel_record: (cancel_records[p.id]!==undefined)?cancel_records[p.id]:{
            product_id: p.id,
            cancel_reason: null,
            saved_reason: null,
            is_transfer: false,
            cease_or_transfer_date: null,
            retention_lead_id: this.ret_account.id,
            status: 'WIP'
          },
          ...p,
          transferDateOpen: false,
          canrec_id: (cancel_records[p.id]!==undefined)?`${cancel_records[p.id].id}{${p.id}}`:`new_${p.id}`,
          is_selected: (cancel_records[p.id]!==undefined)?true:false,
          contract_end_date: (p.contract_start_date!==null)?moment(p.contract_start_date).add(p.contract_length_months,'months').format('YYYY-MM-DD'):''
        });
      });

      this.createStatusItems();

      this.loading_prods = false;
      
      this.fetchCRMUsers();

      window.addEventListener("beforeunload", function(e) {
        if(this.any_changes){
          e.preventDefault();
          e.returnValue = '';
        }else{
          return true;
        }
      });
    },

    methods: {
      ...mapActions('globals', ['addRecentlyViewed']),
      ...mapActions('retention',['getAuditHistory','getRetentionLead','createRetentionLeadRecord','updateRetentionLeadRecord','updateRetentionLead']),
      ...mapActions('products',['getAccountProducts']),
      ...mapActions("accounts", ["getCurrentAccount","getAccountNotes","getAccountEscalation","removeAccountEscalation","sendPaymentLinkEmail","sendAccStatement","getCreditData","sendDDMandate","sendContactRequest","sendPortalInvite","resetAccountState"]),
      ...mapActions("alerts", ["setAlert"]),
      ...mapActions("retention/adhocInvoice", ["fetchAdhocInvoiceData"]),
      ...mapActions("crmUsers", ["fetchCRMUsers"]),

      stripHttps(url) {
        return url ? url.replace(/(^\w+:|^)\/\//, '') : "-";
      },

      sortCliUrl(prod){
        let prodKind = prod.product_kind.toLowerCase();
        let cliUrl = '-';
        if(prodKind==='web'){
          const intURL = this.stripHttps(prod.service.internal);
          const extURL = this.stripHttps(prod.service.external);
          cliUrl = `${ intURL !== '-' ? `<a href="https://${intURL}" target="_blank">${intURL}</a>` : '-' }
                    <br />
                    ${ extURL !== '-' ? `<a href="https://${extURL}" target="_blank">${extURL}</a>` : '-' }`;
        }else if(prodKind==='voip'){
          cliUrl = '';
          prod.service.clis.forEach(cli => { cliUrl += `<tr>${cli}</tr>`; });
          cliUrl = (cliUrl==='')?'-':cliUrl;
        }else{
          cliUrl = prod.service.line_number;
        }
        return cliUrl;
      },

      sortCancelCats(prod){
        let cat = (prod.cancel_record.contact_category!==null)?prod.cancel_record.contact_category:{};
        let rea = (prod.cancel_record.contact_reason!==null)?prod.cancel_record.contact_reason:{};
        let sub = (prod.cancel_record.contact_sub_reason!==null)?prod.cancel_record.contact_sub_reason:'';
        if(this.ret_account.status.toLowerCase() !== "closed") {
          this.getDropdowns.categories.forEach(c => {
            if(cat===c.text){ cat = c; }
          });
          if(cat!==undefined){
            if(cat.value!==undefined){
              this.getDropdowns.reasons[cat.value].forEach(r => {
                if(rea===r.text){ rea = r; }
              });
              if(rea.value!==undefined){
                this.getDropdowns.subReasons[rea.value].forEach(s => {
                  if(sub===s.text){ sub = s; }
                });
              }
            }
          }else{
            return { cat:'',rea:'',sub:'' };
          }
        }
        return { cat:cat,rea:rea,sub:sub };
      },

      close() { this.$router.push(`/retention/`); },

      goToBilling() { this.$router.push(`/accounts/${this.account_id}/`); },

      cancelFeeProf() { this.ret_account.cancellation_fee = (this.ret_account.proforma_fee!==null)?parseFloat(this.ret_account.proforma_fee).toFixed(2):0.00; },

      getClosedAction(prod,kind) {
        let rec = prod.cancel_record;
        let action = '';
        if(prod.confirmed_date===null) {
          if(rec.status==='Lost'){ action = `Move to DOA`;}
          else if(rec.status==='Saved'){ action = `Do nothing`;}
        } else {
          if(kind.toLowerCase()==='voip'&&rec.is_transfer&&rec.status==='Lost'){ action = `Move to Transfer Out` }else
          if(kind.toLowerCase()==='telco'&&rec.is_transfer&&rec.status==='Lost'){ action = `Move to Transfer Out` }else
          if(kind.toLowerCase()==='telco'&&rec.is_transfer&&rec.status==='Saved'){ action = `Move to Transfer Out: Rejected` }else
          if(rec.is_transfer&&rec.status==='Lost'){ action = `Move to Transfer Out: Accepted`;}else 
          if(rec.is_transfer&&rec.status==='Saved'){ action = `Move to Transfer Out: Rejected`;}else
          if(!rec.is_transfer&&rec.status==='Lost'&&prod.confirmed_date!==null){
            if(rec.cease_or_transfer_date) {
              action = `Cease date ${rec.cease_or_transfer_date}`;
            } else {
              action = `Cease date not set`;
            }
            
          }else 
          if(rec.status==='No Contact'){ action = `Send "No Contact" SMS and Email to customer`; }
        }
        return action;
      },

      isStatusClosed() { 
        if(this.ret_account.status !== 'Closed'){
          this.addChange('status',this.ret_account.status);
        }
      },

      createStatusItems() {
        this.statuses = [];
        
        if(this.ret_account.status === "New") {
          this.statuses.push(...["New", "Open"]);
        } else if(this.ret_account.status === "Open") {
          this.statuses.push(...["Open", "Closed"]);
        } else if(this.ret_account.status === "Closed") {
          this.statuses.push("Closed");
        } 
      },

      selectProduct(id) {
        event.preventDefault(); event.stopPropagation();
        if(confirm(`Are you sure you want to add Product ${id} to this retention lead?`)){  this.retProducts[`p_${id}`].is_selected = true; }
      },

      getAccountData() {
        const accountId = this.account_id;
        this.getCurrentAccount(accountId);
      },

      capitalizeFirstLetter(str) { if(str){ return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase(); } return str; },

      addChange(key,update){
        if(!this.any_changes){ this.any_changes = true; }
        if(/cr__/.test(key)){
          key = key.replace('cr__','__');
          let fkey = /__(.*)__/.exec(key);
          let objname = key.replace(fkey[0],'');
          let prodid = false;
          if(/{/.test(objname)){
            let fpid = /{(.*)}/.exec(key);
            objname = objname.replace(fpid[0],'');
            prodid = fpid[1];
          }
          let subkey = fkey[1];
          if(this.updates['cancellation_records']===undefined){ this.$set(this.updates, 'cancellation_records', {} )}
          if(this.updates['cancellation_records'][objname]===undefined){ this.updates['cancellation_records'][objname] = {} }
          this.updates['cancellation_records'][objname][subkey] = update;
          if(prodid!==false&&this.updates['cancellation_records'][objname]['product_id']===undefined){
            this.updates['cancellation_records'][objname]['product_id'] = prodid;
          }
          if(prodid!==false && update.toLowerCase() === "lost") {
            this.$set(this.retProducts[`p_${prodid}`].cancel_record, 'cease_or_transfer_date', null);
          }
        }else{
          if(key==='agent_sid'){
            if(this.ret_account.status==='New'){
              this.ret_account.status = 'Open';
              this.$set(this.updates, 'status', 'Open');
            }
          }
          this.$set(this.updates, key, update);
        }
      },

      closeRetentionLead(){
        this.addChange('status','Closed');
        this.saveRetentionLead();
      },

      async saveRetentionLead(){
        this.save_loading = 1;
        let updates = this.updates;
        let canrecs = false;
        let all_calls = [];

        if(updates.cancellation_records!==undefined){
          let update_calls = [];
          let new_calls = [];
          canrecs = updates.cancellation_records;
          delete updates.cancellation_records;

          Object.keys(canrecs).forEach(key=>{
            let record = canrecs[key];
            if(/new_/.test(key)){
              key = key.replace('new_','');
              new_calls.push({
                product_id: key,
                contact_category: (record.contact_category!==undefined)?record.contact_category:null,
                contact_reason: (record.contact_reason!==undefined)?record.contact_reason:null,
                contact_sub_reason: (record.contact_sub_reason!==undefined)?record.contact_sub_reason:null,
                saved_reason: (record.saved_reason!==undefined)?record.saved_reason:null,
                is_transfer: (record.is_transfer!==undefined)?record.is_transfer:false,
                cease_or_transfer_date: (record.cease_or_transfer_date!==undefined)?record.cease_or_transfer_date.replace(/-/g,'/'):null,
                retention_lead_id: this.ret_account.id,
                status: (record.status!==undefined)?record.status:'WIP'
              });
            }else{
              let rel_prod = this.retProducts[`p_${record.product_id}`].cancel_record;
              update_calls.push({
                id: key,
                product_id: record.product_id,
                contact_category: (record.contact_category!==undefined)?record.contact_category:rel_prod.contact_category.text,
                contact_reason: (record.contact_reason!==undefined)?record.contact_reason:rel_prod.contact_reason.text,
                contact_sub_reason: (record.contact_sub_reason!==undefined)?record.contact_sub_reason:rel_prod.contact_sub_reason,
                saved_reason: (record.saved_reason!==undefined)?record.saved_reason:rel_prod.saved_reason,
                is_transfer: (record.is_transfer!==undefined)?record.is_transfer:rel_prod.is_transfer,
                cease_or_transfer_date: (record.cease_or_transfer_date!==undefined)?record.cease_or_transfer_date.replace(/-/g,'/'):rel_prod.cease_or_transfer_date,
                retention_lead_id: this.ret_account.id,
                status: (record.status!==undefined)?record.status:rel_prod.status
              });
            }
          });
          if(update_calls.length){
            update_calls.forEach((call)=>{
              all_calls.push(new Promise((resolve,reject)=>{
                this.updateRetentionLeadRecord(call).then(()=>{
                  if(!this.retentionLeadRecord){
                    this.any_changes = false;
                    this.save_loading = 0;
                    reject(err);  
                  }else{ resolve(true); }
                });
              }));
            });
          }
          if(new_calls.length){
            new_calls.forEach((call)=>{
              all_calls.push(new Promise((resolve,reject)=>{
                this.createRetentionLeadRecord(call).then(()=>{
                  if(!this.retentionLeadRecord){
                    this.any_changes = false;
                    this.save_loading = 0;
                    reject(err);  
                  }else{ resolve(true); }
                });
              }));
            });
          }
        }
        if(all_calls.length!==0){
          Promise.all(all_calls).then((res)=>{
            let errors = 0;
            res.forEach((r)=>{ if(!r){ errors++; } });
            if(errors===0&&Object.keys(updates).length!==0){
              let patchData = {
                id: this.ret_account.id,
                data: updates
              };
              this.updateRetentionLead({data:patchData}).then(()=>{
                this.getAuditHistory(this.id);
                this.initial_status = this.ret_account.status;
                this.updates = {};
                this.save_loading = 2;
                setTimeout(()=>{
                  this.any_changes = false;
                  this.save_loading = 0;
                  if(this.status_to_closed){ 
                    this.retentionLeadClosedSuccess = true;
                    window.location.reload(); 
                  }
                },2500);
                this.createStatusItems();
              }).catch((err) => {
                this.ret_account.status = this.initial_status;
                this.updates.status = this.initial_status;
                this.any_changes = false;
                this.save_loading = 0;
                this.setAlert({ type: "error", message: err ? err.response.data.message : err });
              });
            }else{
              if(errors===0){
                this.getAuditHistory(this.id);
                this.updates = {};
                this.save_loading = 2;
                setTimeout(()=>{
                  this.any_changes = false;
                  this.save_loading = 0;
                  if(this.status_to_closed){ window.location.reload(); }
                },2500);
              }
            }
          });
        }else{
          if(Object.keys(updates).length!==0){
            let patchData = {
              id: this.ret_account.id,
              data: updates
            };
            this.updateRetentionLead({data:patchData}).then(()=>{
              this.getAuditHistory(this.id);
              if (this.updates.hasOwnProperty('status')) {
                this.updateStatusOpen = false;
                this.initial_status = updates.status;
              }
              this.updates = {};
              this.save_loading = 2;
              setTimeout(()=>{
                this.any_changes = false;
                this.save_loading = 0;
                if (this.status_to_closed) { 
                  this.retentionLeadClosedSuccess = true;
                  window.location.reload(); 
                }
              },2500);
              this.createStatusItems();
            }).catch((err) => {
              this.ret_account.status = this.initial_status;
              this.updates.status = this.initial_status;
              this.any_changes = false;
              this.save_loading = 0;
              this.setAlert({ type: "error", message: err ? err.response.data.message : err });
            });
          }
        }
      },

      topMenuClicked(menuItem) {
        switch(menuItem) {
          case 'openSendProformaInvoiceDialog':
            this.sendProformaInvoiceOpen = true;
            break;
        }
      },

      saveUpdateStatus() {
        if (this.ret_account.status === 'Closed') {
          this.status_to_closed = true;
          return;
        }

        if (this.any_changes) {
          this.saveRetentionLead();
        } else {
          this.closeUpdateStatus();
        }
      },

      closeUpdateStatus() {
        this.updateStatusOpen = false;
        this.ret_account.status = this.initial_status;
        this.any_changes = false;
        delete this.updates.status;
      }
    },
  };
</script>

<style lang="scss">
  .v-data-table__expanded__content { background: #F5F5F5; }
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
    padding-left: 10px !important;
  }

  .products__subtitle {
    color: rgba(0, 0, 0, 0.87);
  }
</style>
